import React from "react";
import Clock from "../../../../shared/assets/icons/clock.svg";
import { HintChip } from "../../../../shared/ui/HintChip";
import { QrBlock } from "../../../../shared/ui/QrBlock";
import styles from "./index.module.scss";
import { Loader } from "../../../../shared/ui/Loader";
import { useAppSelector } from "../../../../shared/store";
import { FileInput } from "../../../../shared/ui/FileInput";
import { useState } from "react";
import { sendVerification } from "../../../../shared/store/payment/api";
import { Button } from "../../../../shared/ui/Button";
import { SIGNATURES } from "../../../../shared/consts";
import { OverlayLoader } from "../../../../shared/ui/OverlayLoader";

export const CheckPayment = () => {
  const offerData = useAppSelector((state) => state.payment.offer);
  const [file, setFile] = useState<File | null>(null);
  const [isFileCorrect, setFileCorrect] = useState<boolean>(true);
  const changeFileStatus = (status: boolean) => {
    setFileCorrect(status);
  };
  const [isSending, setSendingStatus] = useState<boolean>(false);

  const sendVerif = async () => {
    if (offerData && file) {
      setSendingStatus(true);
      await sendVerification(file, offerData.id, "", "");
      setSendingStatus(false);
    }
  };

  return (
    <div className={styles.screen}>
      {isSending && <OverlayLoader />}

      <div className={styles.card}>
        <div className={styles.icon_wrap}>
          <img src={Clock} className={styles.icon} alt="" />
        </div>

        <h1 className={styles.title}>Проверяем оплату</h1>

        <p className={styles.order}>
          {offerData ? `Номер заказа ${offerData.humanId}` : <Loader />}
        </p>

        <p className={styles.text}>
          Загрузите PDF‑чек в форму ниже для завершения оплаты.
        </p>

        <FileInput
          file={file}
          setFile={setFile}
          isFileCorrect={isFileCorrect}
          setFileCorrect={changeFileStatus}
          placeholder={
            offerData?.canUploadVerificationImages
              ? "Выберите файл"
              : "Выберите PDF файл"
          }
          accept={
            offerData?.canUploadVerificationImages
              ? "application/pdf, image/png, image/jpeg, image/jpg"
              : "application/pdf"
          }
          signatures={
            offerData?.canUploadVerificationImages
              ? [...SIGNATURES.pdf, ...SIGNATURES.jpg, ...SIGNATURES.png]
              : SIGNATURES.pdf
          }
          warn={
            offerData?.canUploadVerificationImages
              ? "Необходимо загрузить корректный файл"
              : "Необходимо загрузить PDF файл"
          }
        />

        <div className={styles.actions}>
          <Button content={"Отправить чек"} onClick={sendVerif} className={styles.btn} />
          {offerData?.goodLink && (
            <a className={styles.back_link} href={offerData.goodLink}>
              Вернуться на сайт
            </a>
          )}
        </div>

        <HintChip className={styles.hint}>
            {offerData?.canUploadVerificationImages
              ? "Доступна загрузка PDF, PNG, JPG"
              : "Загрузка доступна только для PDF"}
          </HintChip>
      </div>

      <QrBlock />
    </div>
  );
};
